import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable, throwError } from "rxjs";

import { AppSessionService } from "../app-session/app-session.service";

import { PaginationRequest } from "src/app/models/common/paginationRequest";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class CountriesService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  getCountries(pageReq: PaginationRequest): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Content-type",
      "application/x-www-form-urlencoded; "
    );

    if (pageReq && pageReq.query && (<string>pageReq.query).length > 0) {
      headers = this.setPageReqQuery(headers, pageReq);
    }

    let url = `${this.appSession.baseUrl + '/api/v1/countries'}`;

    if (!pageReq) {
      pageReq = this.setDefaultPageReq();
    }

    const pagination = this.setPagination(pageReq);
    url = url.concat(pagination);

    return this.http.get(url, { headers });
  }

  getSimpleCountries(pageReq: PaginationRequest): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    if (pageReq && pageReq.query && (<string>pageReq.query).length > 0) {
      headers = this.setPageReqQuery(headers, pageReq);
    }

    let url = `${this.appSession.baseUrl + '/api/v1/countries'}`;

    if (!pageReq) {
      pageReq = this.setDefaultPageReq();
    }

    const pagination = this.setPagination(pageReq);
    url = url.concat(pagination);

    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  setDefaultPageReq() {
    return {
      offset: 0,
      limit: 200,
      realSize: false,
    };
  }

  setPageReqQuery(headers: HttpHeaders, pageReq: PaginationRequest) {
    return headers.set("query", pageReq.query);
  }

  setPagination(pageReq: PaginationRequest) {
    return "?offset=" + pageReq.offset + "&limit=" + pageReq.limit + "&real_size=" + pageReq.realSize;
  }

  getDefaultRegionalSettings(countryCode: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.appSession.baseUrl}/api/v1/countries/${countryCode}/defaultRegionalSettings`;

    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }
}
